import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { IIndexer } from '@app/core/models/interfaces/i-indexer';
import { ITranscription } from '@app/core/models/interfaces/i-transcriptions';
import { VideoV3Service } from '@app/shared/services/video-v3.service';
import { ModalManagementService } from '@app/shared/utils/modal-management.service';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-transcription',
  templateUrl: './transcription.component.html',
  styleUrls: ['./transcription.component.scss']
})
export class TranscriptionComponent implements OnInit {

  transcriptionType: string;
  videoId: string;
  searchTerm: string;

  transcriptions: ITranscription[];
  narratedBibles: IIndexer[];
  loadingSkeleton = false;

  constructor(
    private router: Router,
    private activeModal: NgbActiveModal,
    private modalManagementService: ModalManagementService,
    private transcriptionsServices: VideoV3Service
  ) { }

  ngOnInit(): void {
    this.loadingSkeleton = true;
    if(this.transcriptionType == "automatedTranscription"){
      this.getTranscriptions();
    }
    else{
      this.getNarratedBible();
    }
  }

  get transcriptionTitle(): string {
    return this.transcriptionType === 'automatedTranscription'
      ? 'Transcripción automatizada'
      : 'Índice Biblia narrada';
  }

  get transcriptionSourceLabel(): string {
    return this.transcriptionType === 'automatedTranscription'
      ? 'la transcripción automatizada'
      : 'los versículos';
  }

  getTranscriptions(): void {
    this.transcriptionsServices.getTranscriptions(this.videoId, null).subscribe(transcriptions => {
      this.transcriptions = this.filterTranscriptionsBySearchTerm(transcriptions, this.searchTerm);
      this.loadingSkeleton = false;
    }, () => {
      this.loadingSkeleton = false;
    })
  }

  getNarratedBible(): void {
    this.transcriptionsServices.getIndexes(this.videoId).subscribe(transcriptions => {
      const parsedData = this.parseNarratedBible(transcriptions);
      this.narratedBibles = this.filterNarratedBibleBySearchLinesOnly(parsedData, this.searchTerm);
      this.loadingSkeleton = false;
    }, () => {
      this.loadingSkeleton = false;
    })
  }

  filterTranscriptionsBySearchTerm(transcriptions: any[], searchTerm: string): any[] {
    if (!searchTerm) return transcriptions;

    const cleanSearch = this.removeDiacritics(searchTerm.trim().toLowerCase());

    return transcriptions.filter(item =>
      item.lines.some(line => {
        const cleanLine = this.removeDiacritics(line.toLowerCase());
        return cleanLine.includes(cleanSearch);
      })
    );
  }

  filterNarratedBibleBySearchLinesOnly(data: any[], searchTerm: string): any[] {
    if (!searchTerm) return data;

    const cleanSearch = this.removeDiacritics(searchTerm.trim().toLowerCase());

    return data.filter(item =>
      item.lines.some(line => {
        const lineClean = this.removeDiacritics(line.trim().toLowerCase());
        return lineClean.includes(cleanSearch);
      })
    );
  }

  filterTranscriptionsByTerm(transcriptions: any[], searchTerm: string): any[] {
    if (!searchTerm) return transcriptions;

    const lowerTerm = searchTerm.toLowerCase();

    return transcriptions.filter(item =>
      item.lines.some(line => {
        const contentToSearch = line.includes('#') ? line.split('#')[1] : line;
        return contentToSearch && contentToSearch.toLowerCase().includes(lowerTerm);
      })
    );
  }

  parseNarratedBible(rawData: any[]): any[] {
    return rawData.map(item => {
      const lineText = item.lines[0].trim();

      if (!lineText.includes('#')) {
        return {
          startTime: item.startTime,
          endTime: item.endTime,
          title: lineText.replace(/^\\?t/, '').trim(),
          lines: [''],
        };
      }

      const [rawTitle, ...rawLines] = lineText.split('#');
      const cleanTitle = rawTitle.replace(/^\\?t/, '').trim();
      const lines = rawLines.join('#').trim();

      return {
        startTime: item.startTime,
        endTime: item.endTime,
        title: cleanTitle,
        lines: [lines],
      };
    });
  }

  removeDiacritics(str: string): string {
    return str.normalize('NFD').replace(/[\u0300-\u036f]/g, '');
  }

  goToWatch(transcriptions: any): void {
    this.router.navigate(['/watch', this.videoId,], {
      queryParams: { second: transcriptions.startTime }
    });
    this.closeModal();
  }

  private executeAnimateBottom(canHandleResult: boolean): void {
    this.modalManagementService.executeAnimateBottom(
      this.activeModal, 
      canHandleResult,  
      null, 
      '.modal-transcription');
  }

  public closeModal(canHandleResult: boolean = false): void {
    this.executeAnimateBottom(canHandleResult);
  }

}


